import styled from 'styled-components'

export const ScreenContainer = styled.div`
    width: 100%;
    max-width: 100%;
    min-width: 0;

    .error-text {
        color: ${({ theme }) => theme.colors.danger};
    }
    .field-error {
        color: ${({ theme }) => theme.colors.danger};
        font-size: 12px;
        margin-top: 4px;
    }
    .banner-error {
        padding: 10px 14px;
        background: #fef2f2;
        border: 1px solid #fecaca;
        border-radius: 6px;
        color: #7f1d1d;
        margin-bottom: 12px;
    }
    .banner-warn {
        padding: 10px 14px;
        background: #fef3c7;
        border: 1px solid #fde68a;
        border-radius: 6px;
        color: #713f12;
        margin-bottom: 12px;
    }
`

export const SectionCard = styled.div`
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 16px 20px;
    margin-bottom: 16px;
`

export const SectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 12px;
    flex-wrap: wrap;

    h3 {
        margin: 0;
        font-size: 15px;
        font-weight: 600;
    }

    p {
        margin: 2px 0 0;
        color: #6b7280;
        font-size: 12px;
    }
`

export const FilterRow = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 10px;
`

export const StatusBadge = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 500;
    background: ${({ $color }) =>
        ({
            green: '#ecfdf5',
            orange: '#fef3c7',
            red: '#fef2f2',
            grey: '#f3f4f6',
        })[$color] || '#f3f4f6'};
    color: ${({ $color }) =>
        ({
            green: '#16a34a',
            orange: '#92400e',
            red: '#dc2626',
            grey: '#6b7280',
        })[$color] || '#6b7280'};
`

export const HoldBadge = styled(StatusBadge)`
    margin-left: 6px;
`

export const FormGrid = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) 320px;
    gap: 32px;
    align-items: start;
    width: 100%;
    min-width: 0;

    > * {
        min-width: 0;
    }

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 20px;
    }
`

export const PreviewColumn = styled.div`
    position: sticky;
    top: 16px;
    align-self: start;
    z-index: 2;
    width: 320px;
    max-width: 100%;
    min-width: 0;

    @media (max-width: 768px) {
        position: static;
        width: 100%;
    }
`

export const PreviewCard = styled.div`
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 20px;
    font-size: 12px;
    height: fit-content;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-wrap: anywhere;

    .preview-title {
        text-transform: uppercase;
        color: #9ca3af;
        font-size: 11px;
        margin-bottom: 12px;
        letter-spacing: 0.06em;
        font-weight: 700;
    }

    .preview-row {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 12px;
        padding: 8px 0;
        border-bottom: 1px dashed #e5e7eb;

        &:last-child {
            border-bottom: 0;
        }

        .label {
            color: #6b7280;
            flex: 0 0 auto;
            max-width: 40%;
        }

        .value {
            color: #111827;
            font-weight: 600;
            text-align: right;
            flex: 1 1 auto;
            min-width: 0;
            word-break: break-word;
            overflow-wrap: anywhere;
        }
    }

    .window-highlight {
        background: #eff6ff;
        margin: 8px -20px 0;
        padding: 12px 20px;
        border-top: 1px solid #dbeafe;

        .preview-row .value {
            color: #1d4ed8;
        }
    }
`

export const RecentFiresSection = styled.div`
    margin-top: 24px;
    width: 100%;
    min-width: 0;
    overflow-x: auto;

    h4 {
        margin: 0 0 8px;
        font-size: 14px;
    }
`

export const NewBadge = styled.span`
    display: inline-block;
    background: #fef3c7;
    color: #92400e;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: 4px;
    vertical-align: middle;
    margin-left: 8px;
    letter-spacing: 0.5px;
`

export const WindowCard = styled.div`
    border: 1px solid #f59e0b;
    border-radius: 8px;
    padding: 14px;
    background: #fffbeb;
    margin-top: 8px;

    .kind-label {
        font-weight: 700;
        font-size: 13px;
        color: #111827;
    }

    .kind-help {
        color: #6b7280;
        font-size: 12px;
        margin: 4px 0 0;
        line-height: 1.45;
    }
`

export const WindowSubRow = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    margin-top: 10px;
    flex-wrap: wrap;
    font-size: 13px;
`

export const WeekStartPill = styled.button`
    padding: 8px 14px;
    border: 1px solid
        ${({ $active }) => ($active ? '#2563eb' : '#d1d5db')};
    border-radius: 6px;
    background: ${({ $active }) => ($active ? '#eff6ff' : '#fff')};
    color: ${({ $active }) => ($active ? '#1d4ed8' : '#111827')};
    font-weight: ${({ $active }) => ($active ? 600 : 400)};
    font-size: 13px;
    cursor: pointer;
    font-family: inherit;
`

export const ToggleCard = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    background: #f9fafb;
    border-radius: 6px;
    border: 1px solid #e5e7eb;
    margin-bottom: 8px;

    strong {
        display: block;
        font-size: 13px;
    }

    small {
        color: #6b7280;
        font-size: 11.5px;
    }
`

export const DayPicker = styled.div`
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 6px;
`

export const DayCell = styled.button`
    padding: 9px 0;
    text-align: center;
    border: 1.5px solid
        ${({ $selected }) => ($selected ? '#2563eb' : '#e5e7eb')};
    border-radius: 5px;
    font-size: 12px;
    font-weight: 500;
    background: ${({ $selected }) => ($selected ? '#eef2ff' : 'white')};
    color: ${({ $selected }) => ($selected ? '#2563eb' : '#111827')};
    cursor: pointer;
`

export const MonthGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 4px;
`

export const MonthCell = styled.button`
    padding: 6px 0;
    text-align: center;
    border: 1.5px solid
        ${({ $selected }) => ($selected ? '#2563eb' : '#e5e7eb')};
    border-radius: 4px;
    font-size: 11px;
    background: ${({ $selected }) => ($selected ? '#eef2ff' : 'white')};
    color: ${({ $selected }) => ($selected ? '#2563eb' : '#111827')};
    font-weight: ${({ $selected }) => ($selected ? 600 : 400)};
    cursor: pointer;
`

export const FooterActions = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    padding-top: 12px;
    border-top: 1px solid #e5e7eb;
    margin-top: 8px;
`

export const EmptyState = styled.div`
    padding: 60px 20px;
    text-align: center;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 8px;

    .icon {
        font-size: 48px;
        margin-bottom: 12px;
    }

    h3 {
        margin: 0 0 8px;
    }

    p {
        color: #6b7280;
        margin: 0 auto 20px;
        max-width: 400px;
    }
`

export const ModalKv = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 6px 0;
    border-bottom: 1px dashed #e5e7eb;
    font-size: 13px;

    &:last-child {
        border-bottom: 0;
    }

    .k {
        color: #6b7280;
    }

    .v {
        font-weight: 500;
        text-align: right;
        max-width: 60%;
    }
`

export const ErrorPre = styled.pre`
    background: #f3f4f6;
    padding: 8px;
    border-radius: 4px;
    font-size: 11px;
    max-height: 120px;
    overflow: auto;
    white-space: pre-wrap;
    margin: 4px 0 0;
`

export const SkeletonLine = styled.div`
    height: 14px;
    width: ${({ $width }) => $width || '60%'};
    background: #e5e7eb;
    border-radius: 4px;
    animation: pulse 1.2s ease-in-out infinite;

    @keyframes pulse {
        0%,
        100% {
            opacity: 1;
        }
        50% {
            opacity: 0.5;
        }
    }
`
